<!--Richtext component (cleaned) from Wagtail
-->

<template>
  <main :class="`${this.block.value.color.color_choice}-color`">
    <mdb-container fluid>
      <mdb-row class="py-5 px-2">
        <mdb-col>
          <mdb-container>
            <mdb-row>
              <mdb-col class="text-left">
                <div v-html="block.value.richtext"></div>
              </mdb-col>
            </mdb-row>
          </mdb-container>
        </mdb-col>
      </mdb-row>
    </mdb-container>
    <div :class="{ 'component-pattern': block.value.pattern.show_pattern}"></div>
  </main>
</template>

<script>
import { mdbContainer, mdbCol, mdbRow } from "mdbvue";
export default {
  props: {
    block: Object,
  },
  components: {
    mdbContainer,
    mdbCol,
    mdbRow,
  },
  name: "full_richtext",
};
</script>